import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

const reviews = [
  {
    id: 1,
    image: "assets/images/apc.png",
    name: "AllPeoples Church",
    review: "JoltChat is a game changer. Our Pastors can now see exactly who is in each group and communicate with them easily.",
    imageClass: "w-full"
  },
  {
    id: 2,
    image: "assets/images/chloe.JPG",
    name: "Chloe",
    review: "As a group leader, I love that I don't have to worry about inputting data to PCO anymore!",
    imageClass: "w-full rounded-full"
  },
  {
    id: 3,
    image: "assets/images/kcf.jpeg",
    name: "Kauai Christian Fellowship",
    review: "JoltChat has helped us level up and reach new people easily.",
    imageClass: "w-full"
  },
  {
    id: 4,
    image: "assets/images/ah.jpeg",
    name: "Anchor House",
    review: "Young people are only using group messaging apps. JoltChat has met them where they are at.",
    imageClass: "w-full rounded-full"
  },
  {
    id: 5,
    image: "assets/images/hudson.JPG",
    name: "Hudson - Young Adult Pastor",
    review: "JoltChat is going to revolutionize how the Church communicates and bring unity to our communities.",
    imageClass: "w-full rounded-full"
  }
];

const Reviews = () => {
  return (
    <div id="reviews" className="our-portfolio section">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap">
          <div className="w-full lg:w-5/12">
            <div className="section-heading wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.3s">
              <h6 className="text-lg font-semibold">Our Reviews</h6>
              <h4 className="text-3xl font-bold">See What People are <em>Saying</em></h4>
              <div className="line-dec"></div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="container-fluid mx-auto wow fadeIn" data-wow-duration="1s" data-wow-delay="0.7s">
        <div className="flex flex-wrap">
          <div className="container mx-auto px-4">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={30}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false
              }}
              pagination={{
                clickable: true
              }}
              loop={true}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                600: {
                  slidesPerView: 2,
                },
                1000: {
                  slidesPerView: 4,
                },
              }}
              className="mySwiper"
            >
              {reviews.map((review) => (
                <SwiperSlide key={review.id}>
                  <div className="portfolio-item px-5">
                    <div className="thumb p-2">
                      <img src={review.image} alt="" className={review.imageClass} />
                    </div>
                    <div className="down-content">
                      <i className="fas fa-star" style={{ color: 'gold' }}></i>
                      <i className="fas fa-star" style={{ color: 'gold' }}></i>
                      <i className="fas fa-star" style={{ color: 'gold' }}></i>
                      <i className="fas fa-star" style={{ color: 'gold' }}></i>
                      <i className="fas fa-star" style={{ color: 'gold' }}></i>
                      <h4 className="text-xl font-bold mt-4">{review.name}</h4>
                      <span className="text-gray-600">{review.review}</span>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
    
        {/* Blockquote Section */}
        <div className="blockquote-wrapper">
          <div className="blockquote-img p-10">
            <img src="assets/images/hudson-mic2.JPG" alt="" className="rounded-full w-full" />
          </div>
          <div className="blockquote">
            <h6>
              As a pastor and software engineer, I saw a problem: the Church is stuck using outdated communication methods. People avoid email and hate spammy texts, but they’re already using messaging apps every day.
              That’s why I created JoltChat—a platform that meets people where they are. It simplifies communication, keeps your Planning Center database updated automatically, and gives you valuable insights about your people—all without extra work.
              The way we communicate has changed, and with JoltChat, the Church can change with it.
            </h6>
            <h4>
              &mdash; Hudson, Founder & Creator
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;